import React from "react";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../Style/CompanySettings.css";
import { path_url } from "../../Config/config";

const customerSchema = Yup.object().shape({
  duedate: Yup.string().required("Required"),
  subject: Yup.string().required("Required"),
});
const options = [
  { value: "option1", label: "Option 1" },
  { value: "option2", label: "Option 2" },
  { value: "option3", label: "Option 3" },
];

const Priority = [
  { value: "High" },
  { value: "Medium" },
  { value: "Low" },
  { value: "Critical" },
  { value: "Normal" },
  { value: "Emergency" },
  { value: "Deferred" },
];

const Enum = [
  { value: "Open" },
  { value: "InProgress" },
  { value: "Pending" },
  { value: "Completed" },
  { value: "Canceled" },
  { value: "Deferred" },
  { value: "WaitingforCustomer" },
  { value: "WaitingforInternalReview" },
  { value: "Reassigned" },
  { value: "OnHold" },
  { value: "Overdue" },
  { value: "Scheduled" },
  { value: "NeedsMoreInformation" },
  { value: "Escalated" },
  { value: "Closed" },
  { value: "NotApplicable" },
];

function FormLabel({ text, required }) {
  return (
    <label className="cs-label">
      {text}
      {required && <sup>*</sup>}
    </label>
  );
}

export default function Payment() {
  return (
    <>
      <Formik
        initialValues={{
          duedate: "",
          subject: "",
          notes: "",
          assign: "",
          asignedto: "",
          priority: "",
          status: "",
        }}
        validationSchema={customerSchema}
        onSubmit={async (values) => {
          try {
            const token = localStorage.getItem("accessToken");
            const response = await axios.post(`${path_url}/task`, values, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            });
            if (response.data.statusCodeValue === 200) {
              alert("form submitted successfully");
            } else {
              toast.error(response.data.body);
            }
          } catch (errors) {
            console.log(errors);
          }

          console.log(values);
        }}
      >
        {(formik) => (
          <form onSubmit={formik.handleSubmit}>
            <fieldset>
              <div className="cs-section-header">
                <p>Payment</p>
              </div>

              <div className="row">
                <div className="col-12 col-md-6">
                  <div className="cs-form-row">
                    <FormLabel text="Allow Bank Payments" />
                    <div className="cs-field-wrap cs-switch-wrapper">
                      <div className="custom-control custom-switch">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customSwitches"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="customSwitches"
                        ></label>
                      </div>
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Bank Name" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Subject"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Bank Branch No." />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Subject"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Payment Account No." />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Subject"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Payment Routing No." />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Subject"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <div className="cs-form-row">
                    <FormLabel text="Giro No." />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Subject"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Swift Code" />
                    <div className="cs-field-wrap">
                      <Field
                        as="select"
                        name="assignedto"
                        id="assignedto"
                        className="cs-select"
                      >
                        <option value="Mobile">John Red</option>
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Field>
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="IBAN" />
                    <div className="cs-field-wrap">
                      <input
                        className="cs-input"
                        type="text"
                        placeholder="Subject"
                        name="subject"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.subject}
                      />
                    </div>
                  </div>

                  <div className="cs-form-row">
                    <FormLabel text="Bank Account Position" />
                    <div className="cs-field-wrap">
                      <Field
                        as="select"
                        name="assignedto"
                        id="assignedto"
                        className="cs-select"
                      >
                        <option value="Mobile">John Red</option>
                        {options.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </Field>
                    </div>
                  </div>

                  <div className="cs-btn-row">
                    <button
                      type="button"
                      className="cs-btn-cancel"
                      onClick={() => formik.resetForm()}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="cs-btn-save">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </Formik>
    </>
  );
}